import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ETacticMetricForm } from '@modules/tactics/modules/tactic-settings/shared/enums/tactic-metric-form.enum';

export const cycleMeasurementValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const cycle = control.get(ETacticMetricForm.cycle);
  const cycleMeasurement = control.get(ETacticMetricForm.cycleMeasurement);

  return (cycle?.value ? !!cycleMeasurement?.value : true) ? null : { cycleMeasurementEmpty: true };
};
